import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import { styled, useTheme } from '@mui/material/styles';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InfoIcon from '@mui/icons-material/Info';
import config from '../../config_general.json';
import { useLanguage } from '../../Language/LanguageContext';
import useTranslation from '../../Language/useTranslation';




export default function LeftSubDrawerDesktop(props: any) {

    const { language } = useLanguage();
    const t = useTranslation();

    const DrawerHeader = styled('div')(({ theme }) => ({

        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: 'flex-start',
    }));
    return (<>
        <Drawer
            //todo: move to own component
            // transitionDuration={0}
            sx={{
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: config.general["leftDrawerWidthDesktop"],
                    boxSizing: 'border-box',
                    overflowX: 'hidden',
                },
            }}
            onClose={() => props.setLeftSubDrawerOpen(false)}
            anchor="left"
            open={props.leftSubDrawerOpen}
            variant="persistent"

        // hideBackdrop={true}

        >
            <DrawerHeader>
                <AppBar
                    position='absolute'
                    sx={{
                        width: config.general["leftDrawerWidthDesktop"],//`${props.drawerWidth}px`,
                        mr: `calc(100% - ${config.general["leftDrawerWidthDesktop"]})`,
                    }}
                >
                    <Toolbar>
                        <Box display='flex' flexGrow={1}>

                            <Typography variant="h6" component="div">
                                {props.title}
                            </Typography>
                        </Box>
                        {props.title == t.layerCategories["waldzustand"].name && <SelectYear version={props.version} setVersion={props.setVersion} />}

                        <IconButton edge="end" color="inherit" aria-label="open drawer" onClick={() => props.setLeftSubDrawerOpen(!props.leftSubDrawerOpen)} >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
            </DrawerHeader>
            <Box sx={{ overflow: "auto" }}>
                {props.children}
            </Box>
        </Drawer>

    </>);
}

function SelectYear({ version, setVersion }: any) {

    const t = useTranslation();

    const handleChange = (event: SelectChangeEvent) => {
        setVersion(event.target.value as string);
    };

    return (
        <FormControl size="small" sx={{ width: 135, mr: 2 }}>
            <InputLabel id="demo-simple-select-label">
                {t.namesUIElements.zeitraumSelect.name}
            </InputLabel>
            <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={version}
                label={t.namesUIElements.zeitraumSelect.name}
                onChange={handleChange}
            >
                <MenuItem value="2016_2020">2016 - 2020</MenuItem>
                <MenuItem value="2020_2021">2020 - 2021</MenuItem>
                <MenuItem value="2021_2022">2021 - 2022</MenuItem>
                <MenuItem value="2022_2023">2022 - 2023</MenuItem>
            </Select>
        </FormControl>

    );
}